import axios from "axios";

export default interface Portfolio {
  id?: number | null;
  iso3: string;
  username: string;
  created_by?: string | null;
  created_at?: string | null;
  geo_name?: string | null;
  geo_group?: string | null;
  user?: string | null;
  assigned_by?: string | null;
  assigned_at?: string | null;
}

export async function getAllPortfolios() {
  let response = await axios.get("/psql/portfolios_view");
  return response.data;
}

export async function setPortfolio(iso3: string, username: string) {
  return axios.post("/psql/portfolios", {
    iso3,
    username,
  });
}
